const roles = [
  { label: 'Dono', value: 'owner' },
  { label: 'Organizador', value: 'organizer' }
]

const getRoleName = (role) => {
  if (!role) return ''

  if (Array.isArray(role)) {
    return role.map(getRoleName).join(', ')
  }

  const roleValue = typeof role === 'object'
    ? role.value || role.name || role.code
    : role
  const mappedRole = roles.find((item) => item.value === roleValue)

  return mappedRole?.label || roleValue || ''
}

export {
  roles,
  getRoleName
}
